/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_SubscriptionInputs */

const en_settings_subscription = /** @type {(inputs: Settings_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription`)
};

const de_settings_subscription = /** @type {(inputs: Settings_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement`)
};

const fr_settings_subscription = /** @type {(inputs: Settings_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement`)
};

const es_settings_subscription = /** @type {(inputs: Settings_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscripción`)
};

const it_settings_subscription = /** @type {(inputs: Settings_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbonamento`)
};

const nl_settings_subscription = /** @type {(inputs: Settings_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement`)
};

const pl_settings_subscription = /** @type {(inputs: Settings_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subskrypcja`)
};

const fi_settings_subscription = /** @type {(inputs: Settings_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilaus`)
};

const da_settings_subscription = /** @type {(inputs: Settings_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement`)
};

const sv_settings_subscription = /** @type {(inputs: Settings_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenumeration`)
};

/**
* | output |
* | --- |
* | "Subscription" |
*
* @param {Settings_SubscriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_subscription = /** @type {((inputs?: Settings_SubscriptionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_SubscriptionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_subscription(inputs)
	if (locale === "fr") return fr_settings_subscription(inputs)
	if (locale === "es") return es_settings_subscription(inputs)
	if (locale === "it") return it_settings_subscription(inputs)
	if (locale === "nl") return nl_settings_subscription(inputs)
	if (locale === "pl") return pl_settings_subscription(inputs)
	if (locale === "fi") return fi_settings_subscription(inputs)
	if (locale === "da") return da_settings_subscription(inputs)
	if (locale === "sv") return sv_settings_subscription(inputs)
	return en_settings_subscription(inputs)
});